import { BillingSeatType, SubscriptionTier } from '@heidi/schema/ml-scribe';
import { useUserBillingInfo } from '../../../../data/injected-billing';
import { getCommerceBillingUiPorts } from '../billing-ui-ports';
import { usePricingPlansUpgradeRole } from './usePricingPlansUpgradeRole';

/**
 * A settled workspace member (non-admin) with something left to ask for: any
 * tier below Practice Max and Enterprise. They cannot buy for the workspace,
 * so their upgrade entry points open the seat request modal rather than the
 * pricing plans modal; once they have asked, that modal holds its CTA as sent.
 */
export function useIsTeamSeatUpgradeRequester(): boolean {
  const isMemberUpgradeRequestEnabled =
    getCommerceBillingUiPorts().useIsHeidi2MemberUpgradeRequestEnabled();
  const { data: billingInfo } = useUserBillingInfo();
  const { isNonAdminWorkspaceMember, isWorkspaceRoleUnresolved } =
    usePricingPlansUpgradeRole();

  const tier = billingInfo?.new_product_tier;
  const isOnPracticeMax =
    tier === SubscriptionTier.CLINICIAN_PRO_PLUS &&
    billingInfo?.seat_type === BillingSeatType.MAX;
  const isOnTopTier = isOnPracticeMax || tier === SubscriptionTier.ENTERPRISE;

  return (
    isMemberUpgradeRequestEnabled &&
    !getCommerceBillingUiPorts().isAppleCompliantBuild() &&
    isNonAdminWorkspaceMember &&
    !isWorkspaceRoleUnresolved &&
    !!tier &&
    !isOnTopTier
  );
}
